import { render } from "./Projection.vue?vue&type=template&id=f31e11a4"
import script from "./Projection.vue?vue&type=script&lang=js"
export * from "./Projection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__